import { VpIcon, VpLink, VpLinkVariantStyle } from '@vtmn-play/react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

interface BackButtonProps {
  onBrand?: boolean
  to?: string
  label?: string
}

const BackButton = ({ onBrand = false, to, label }: BackButtonProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('common')
  const LinkVariantStyle: VpLinkVariantStyle = onBrand ? 'on-brand' : 'regular'
  const iconColorClass = onBrand ? 'text-white' : ''
  const handleNavigation = () => {
    if (to) {
      void navigate(to)
    } else {
      void navigate(-1)
    }
  }

  return (
    <VpLink
      variant="tertiary"
      variantStyle={LinkVariantStyle}
      onClick={handleNavigation}
      startSlot={
        <VpIcon
          data-testid="icon-chevron-backward"
          name="chevron-backward"
          className={twMerge('mb-0.5 text-primary-gray', iconColorClass)}
        />
      }
    >
      {label || t('global.back')}
    </VpLink>
  )
}

export default BackButton
